import {
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { Message } from '../../../../../../core/class/message';
import { CommonService } from '../../../../../../core/services/common.service';
import { BaseComponent } from '../../../../../../shared/components/base/base.component';

@Component({
  selector: 'app-record-management-moha',
  templateUrl: './record-management-moha.component.html',
  styleUrls: ['./record-management-moha.component.scss'],
})
export class RecordManagementMohaComponent extends BaseComponent implements OnInit, OnDestroy {
  isInforTab = 0;

  constructor(
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    super(commonService, message);
    this.notifier = notifier;
  }

  ngOnInit() {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        if (params.currentTab != null) {
          const currentTab = Number(params.currentTab);
          this.isInforTab = currentTab === 1 ? 1 : 0;
        }
      });
  }

  changeTabSelected($event: any){
    this.isInforTab = $event
    const url = new URL(window.location.href);
    url.searchParams.set('currentTab', $event);
    window.history.pushState({}, '', url.toString());
  }

  ngOnDestroy(){

  }
}
